import React, {FunctionComponent} from 'react';
import {useQuery} from '@tanstack/react-query';

import {useCompareParams} from './CompareContent';
import CompareSectionsPage from '../../partials/compare/CompareSectionsPage';
import {useCompareAcademicProgramQueryConfig} from '../../../query/Compare/Query';

interface Props {}

const CompareProgram: FunctionComponent<Props> = () => {
    const [universityIds] = useCompareParams();

    const [compareProgramConfig] = useCompareAcademicProgramQueryConfig(universityIds);
    const compareProgramQuery = useQuery(compareProgramConfig);

    if(!compareProgramQuery.data)
        return null;

    return (
        <CompareSectionsPage parts={compareProgramQuery.data} />
    );
};

export default CompareProgram;
